import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";

export function CookieNotice() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => {
    try {
      return localStorage.getItem("cookie-consent") !== "true";
    } catch {
      return true;
    }
  });
  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem("cookie-consent", "true");
    } catch {
      // Preference storage is optional; dismissal already applies to this mount.
      return;
    }
  };
  if (!visible) return null;
  return (
    <section
      aria-labelledby="privacy-notice-title"
      className="border-b border-border bg-muted text-foreground [overflow-wrap:anywhere]"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 text-sm leading-6">
          <h2 id="privacy-notice-title" className="font-semibold">
            {t("privacyNotice.title")}
          </h2>
          <p className="text-muted-foreground">
            {t("privacyNotice.text")}{" "}
            <Link
              to="/legal/privacy"
              className="inline-flex min-h-11 items-center rounded-sm font-medium text-primary underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              {t("privacyNotice.link")}
            </Link>
          </p>
        </div>
        <Button className="shrink-0" variant="outline" onClick={dismiss}>
          {t("common.ok", "Understood")}
        </Button>
      </div>
    </section>
  );
}
